
import React from 'react';
import { Skeleton } from "@/components/ui/skeleton";

interface LoadingStateProps {
  compact?: boolean;
}

const LoadingState: React.FC<LoadingStateProps> = ({ compact = false }) => {
  if (compact) {
    return (
      <div className="w-full flex flex-col items-center justify-center py-6">
        <div className="h-6 w-6 border-t-2 border-blue-500 border-solid rounded-full animate-spin mb-2"></div>
        <p className="text-sm text-gray-600">Processing data...</p>
      </div>
    );
  }

  return (
    <div className="w-full space-y-6">
      <div className="flex items-center justify-center mb-4">
        <div className="h-6 w-6 border-t-2 border-blue-500 border-solid rounded-full animate-spin mr-3"></div>
        <p className="text-sm text-gray-600 font-medium">Loading data...</p>
      </div>
      
      <div className="space-y-6">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="flex flex-col gap-3 animate-pulse">
            <Skeleton className="h-8 w-full bg-gray-200" />
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              <Skeleton className="h-12 w-full bg-gray-200" />
              <Skeleton className="h-12 w-full bg-gray-200" />
              <Skeleton className="hidden sm:block h-12 w-full bg-gray-200" />
              <Skeleton className="hidden sm:block h-12 w-full bg-gray-200" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoadingState;
